<template>
    <div class="calendar-wrapper">
        <div class="header-container">
            <button @click="prevMonth" class="btn">&#9664;</button>
            <h2 class="month-title">{{ monthYear }}</h2>
            <button @click="nextMonth" class="btn">&#9654;</button>
        </div>
        <div class="grid-container">
            <div v-for="day in weekDays" :key="day" class="week-header">{{ day }}</div>
            <div v-for="(day, index) in daysInMonth"
                :key="index"
                class="day-box"
                :class="{ 'disabled-day': !day.inCurrentMonth, 'selected-day': day.selected }"
                @click="onDateClick(day.date)"
            >
                <span>{{ day.date.getDate() }}</span>
                <div v-if="day.marcado" class="dot" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const emit = defineEmits(['mudouMes', 'clicouData'])
const props = defineProps({
    datasMarcadas: {
        type: Array,
        default: () => []
    }
})
  
const hoje = new Date()
const currentMonth = ref(hoje.getMonth())
const currentYear = ref(hoje.getFullYear())
const selectedDate = ref(hoje)
const weekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

const datasMarcadasConvertidas = computed(() => props.datasMarcadas);
  
const daysInMonth = computed(() => {
    const firstDay = new Date(currentYear.value, currentMonth.value, 1)
    const lastDay = new Date(currentYear.value, currentMonth.value + 1, 0)
    const totalDays = lastDay.getDate()
    const startDay = firstDay.getDay()
    const endDay = 6 - lastDay.getDay()
    const days = []

    // Dias do mês anterior
    for (let i = startDay; i > 0; i--) {
        const date = new Date(currentYear.value, currentMonth.value, -i + 1)
        days.push({ date, inCurrentMonth: false, marcado: false })
    }

    // Dias do mês atual
    for (let i = 1; i <= totalDays; i++) {
        const date = new Date(currentYear.value, currentMonth.value, i)
        const dataISO = date.toISOString().split('T')[0]
        days.push({
            date,
            inCurrentMonth: true,
            marcado: datasMarcadasConvertidas.value.includes(dataISO),
            selected: selectedDate.value?.toDateString() === date.toDateString()
        })
    }
  
    // Dias do mês seguinte
    for (let i = 1; i <= endDay; i++) {
        const date = new Date(currentYear.value, currentMonth.value + 1, i)
        days.push({ date, inCurrentMonth: false, marcado: false })
    }
  
    return days
})

const monthYear = computed(() => {
    return new Intl.DateTimeFormat('pt-BR', { month: 'short', year: 'numeric' })
    .format(new Date(currentYear.value, currentMonth.value))
    .toUpperCase()
    .replace('.', '')
    .replace(' DE ', '/');
});
  
const prevMonth = () => {
    if (currentMonth.value === 0) {
        currentMonth.value = 11
        currentYear.value--
    } else {
        currentMonth.value--
    }
    emit('mudouMes', { mes: currentMonth.value + 1, ano: currentYear.value })
}
  
const nextMonth = () => {
    if (currentMonth.value === 11) {
        currentMonth.value = 0
        currentYear.value++
    } else {
        currentMonth.value++
    }
    emit('mudouMes', { mes: currentMonth.value + 1, ano: currentYear.value })
}
  
function onDateClick(date) {
    selectedDate.value = date
    emit('clicouData', date)
}
  
onMounted(() => {
    emit('mudouMes', { mes: currentMonth.value + 1, ano: currentYear.value })
})
</script>
  
<style scoped>
.calendar-wrapper {
    width: 300px;
    background: #f9f9f9;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
  
.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}
  
.btn {
    background: #5b8b8b;
    color: white;
    border: none;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    max-width: 60px;
}

.month-title {
    font-size: 1rem;
}
  
.grid-container {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
}
  
.week-header {
    text-align: center;
    font-weight: bold;
    font-size: 0.85rem;
    color: #333;
}
  
.day-box {
    text-align: center;
    padding: 6px 0;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    position: relative;
    min-height: 35px;
    box-sizing: border-box; /* <- ESSENCIAL AQUI */
}

.day-box:hover {
    background: #e6f0f0;
}

.disabled-day {
    color: #aaa;
    background: #f1f1f1;
}

.dot {
    width: 6px;
    height: 6px;
    background-color: #42b983;
    border-radius: 50%;
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
}

.selected-day {
    background-color: #e6f7f4;
    box-shadow: 0 0 0 2px #42b983 inset;
    border-radius: 6px;
}
</style>